module.exports = __webpack_public_path__ + "img/1557387.4c190e6f.svg";